// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormFieldIcon } from "@insite/mobius/FormField";
import { IconWrapper } from "@insite/mobius/Icon";
import PaginationPresentationPropsDefault from "@insite/mobius/Pagination/presentationProps";
import ChevronLeft from "@sc/XDL/Icons/ChevronLeft";
import ChevronRight from "@sc/XDL/Icons/ChevronRight";
import { xBaseTheme } from "@sc/XDL/types";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PaginationPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            pagination: css`
                gap: 10px 30px;
                ${xScreen("lte", "md")} {
                    flex-wrap: nowrap;
                }
                ${xScreen("lte", "xs")} {
                    justify-content: space-between;
                    gap: 10px 15px;
                }
            `,
            linkList: css`
                ul {
                    align-items: center;
                }
            `,
        },
        selectProps: {
            cssOverrides: {
                formField: css`
                    display: flex;
                    align-items: center;
                `,
                formInputWrapper: css`
                    width: auto;
                    ${FormFieldIcon} {
                        display: flex;
                        justify-content: center;
                    }
                `,
            },
            labelProps: {
                size: 14,
                weight: "normal",
                css: css`
                    line-height: 22px;
                    flex-shrink: 0;
                    width: initial;
                    padding: 0 8px 0 0;
                `,
            },
            css: css`
                &&&& {
                    padding-right: 24px;
                    text-align: center;
                }
            `,
        },
        navIconsSrc: {
            firstPage: "ChevronsLeft",
            previousPage: ChevronLeft,
            nextPage: ChevronRight,
            lastPage: "ChevronsRight",
        },
        buttonProps: {
            css: css`
                border: none;
                padding: 0;
                margin: 0;
                width: 10px;
                overflow: hidden;
                &:disabled {
                    ${IconWrapper}, ${IconWrapper} svg {
                        color: ${color("common.ui4")};
                    }
                }
                &:not(:disabled):hover {
                    background: none;
                    ${IconWrapper}, ${IconWrapper} svg {
                        color: ${color("common.ui8")};
                    }
                }
                &:not(:disabled):focus {
                    background: none;
                }
                ${IconWrapper}, ${IconWrapper} svg {
                    height: 16px;
                    width: 16px;
                    color: ${color("text.link")};
                }
            `,
        },
    },
} as xBaseTheme["pagination"];
